export let locale: string

export const setJSLocale = (localeToSet?: string) => {
  locale = localeToSet || 'en'
}
